import React from 'react'
import { Route, Routes } from 'react-router-dom'
import NotFoundPage from '../pages/error/404'
import {Container, Row, Col} from 'react-bootstrap'
import Dashboard from '../pages/laboratory/Dashboard'
import Version from '../version'
import Menu from '../components/menus/Menu'
import WorkOrders from '../pages/admin/workOrders/WorkOrders'
import ParametersInput from '../pages/laboratory/ParametersInput'

export default function LaboratoryRouter () {
	return (
		<Container className='contenido p-0'>
			<Menu/>
			<Routes>
				<Route path="/dashboard" element={<Dashboard/>}/>
				<Route path="/workorders" element={<WorkOrders userType="Laboratory"/>}/>
				<Route path="/parametersInput" element={<ParametersInput userType="Laboratory"/>}/>
				<Route path="*" element={<NotFoundPage />}/>
			</Routes>
			<Row>
                <Col className='text-center my-3'>
                    <Version />
                </Col>
            </Row>
		</Container>
	)
}